export enum PackageEnum {
  starter = 'starter',
  basic = 'basic',
  premium = 'premium',
}
